module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-1.76b29c2c.jpg";